<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="9" fill="white" />
    <path d="M9 5C8.68934 5 8.4375 5.25184 8.4375 5.5625V8.4375H5.5625C5.25184 8.4375 5 8.68934 5 9C5 9.31066 5.25184 9.5625 5.5625 9.5625H8.4375V12.4375C8.4375 12.7482 8.68934 13 9 13C9.31066 13 9.5625 12.7482 9.5625 12.4375V9.5625H12.4375C12.7482 9.5625 13 9.31066 13 9C13 8.68934 12.7482 8.4375 12.4375 8.4375H9.5625V5.5625C9.5625 5.25184 9.31066 5 9 5Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'PlusFilled',
};
</script>
